<template>
  <div
    v-if="item.locals?.rarity || item.is_stattrak || item.is_souvenir || item.phase"
    class="tags"
  >
    <div class="tags_wrap f fw fs">
      <div
        v-if="item.locals?.rarity"
        :style="`color:${getNewRarityColor(item.rarity_color!)}`"
        class="f tags_item"
      >
        <!--        {{ item.quality[0] == '★' ? '★' : '' }} -->
        {{ item.locals?.rarity ? item.locals?.rarity : '' }}
        <!--        {{ item.weapon || '' }} -->
      </div>
      <div
        v-if="item.is_stattrak"
        class="f tags_item stattrak"
      >
        StatTrak {{ hideAvailable ? '' : t('available') }}
      </div>
      <div
        v-if="item.is_souvenir"
        class="f tags_item souvenir"
      >
        Souvenir {{ hideAvailable ? '' : t('available') }}
      </div>
      <div
        v-if="item.phase"
        :class="getModifiedString(item.phase)"
        class="f tags_item"
      >
        {{ $t(`phases.${item.phase}`) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ItemPageInfo } from '~/graphql/generated/schema-types';
import { useI18n } from 'vue-i18n';
import getNewRarityColor from '~/utils/get-new-rarity-color';

defineProps<{
  item: ItemPageInfo
  hideAvailable?: boolean
}>();

const { t } = useI18n();
</script>

<style lang="scss" scoped>
@use '/assets/scss/mixins.scss' as *;

.tags {
  margin: 0 0 0.4rem;

  &_wrap {
    margin: 0 -0.5rem;
  }

  &_item {
    @include ellipsis;
    margin: 1rem 0.5rem;
    height: 3.6rem;
    padding: 0.3rem 1.4rem;
    background: var(--surfaces-low-container);
    border-radius: 20rem;
    text-shadow: 0 0 4rem;
  }
}
</style>
